import React from "react";
import "./report.css";

const report = () => {
  return (
    <div className="dashboard-container">
      <h1>Report</h1>
    </div>
  );
};

export default report;
